import { useDispatch } from 'react-redux';

import { StaticModal, useModal } from '@/modules/modals';

import { importValidationRequestCancel, importValidationRequestSuccess } from '../services/actions';
import type { ImportValidationErrorData } from '../types';

export const useImportValidationModal = () => {
    const { modal, updateModal } = useModal<ImportValidationErrorData>(StaticModal.IMPORT_VALIDATION);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(importValidationRequestCancel());
        updateModal(false);
    };

    const handleAccept = () => {
        dispatch(importValidationRequestSuccess());
        updateModal(false);
    };

    return {
        visible: modal?.visibility,
        report: modal?.data,
        handleClose,
        handleAccept,
    };
};
